module.exports = __webpack_public_path__ + "img/mini-app-posttis.f6dd6550.jpg";